module.exports = __webpack_public_path__ + "static/media/icon-toggle-range-plus.f853e09f.svg";